<script setup lang="ts">

withDefaults(defineProps<{
    inline?: boolean
}>(), {
    inline: false,
});

</script>

<template>
    <div :class="[inline ? 'inline-loader' : 'screen-loader']">
        <div
            class="spinner"
        />
    </div>
</template>
<style scoped>
    .screen-loader {
        position: fixed;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 99;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0,0,0,0.7);
        top: 0;
        left: 0;
        bottom: 0;
        pointer-events: none;
    }

    .screen-loader .spinner {
        display: block;
        width: 220px;
        height: 220px;
    }

    .inline-loader,
    .inline-loader .spinner {
        height: 100%;
        width: 100%;
    }

    .spinner {
        background-image:url('./../assets/images/annuity-ready-loading-spinner.svg');
        animation: lds-circle 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    }

    @keyframes lds-circle {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }

</style>
